module.exports = __webpack_public_path__ + "img/Wipev-Logo-XS.493a9827.png";